let measureCanvas: HTMLCanvasElement | null = null;

/** 앱(heritage) 실제 폰트를 computed style 에서 읽음 — 하드코딩 금지(Pretendard Variable 등 로드 폰트 정합). */
function resolvedFont(sizePx: number): string {
  const family =
    typeof document !== 'undefined'
      ? getComputedStyle(document.body).fontFamily || 'system-ui, sans-serif'
      : 'system-ui, sans-serif';
  return `${sizePx}px ${family}`;
}

/**
 * 라벨 목록의 최장 텍스트 폭(px) 실측 + 여백. 스크롤 시 값축 헤더 정렬을 위해 카테고리 폭을 px 로 알아야
 * 하는데(recharts `width="auto"` 는 값 미노출), **실제 폰트로 실측**이라 auto 와 동일 fit. document 부재면
 * 글자수 추정 폴백. `fontPx`=recharts tick fontSize(기본 12). 상한 `max`.
 *
 * 폰트 로드 전(FOUT) 첫 측정은 폴백 폰트 메트릭이라 부정확할 수 있어 — 소비자가 `document.fonts.ready`
 * 후 재측정하면 정합(alignment 는 카테고리 폭을 헤더·plot 이 공유하므로 오차가 있어도 안 깨짐, wrap 만 영향).
 */
/** 실측 옵션 — `fontPx`=tick 폰트, `pad`=라벨 폭에 더할 축 여백, `min`/`max`=결과 clamp. */
export interface MeasureLabelOptions {
  fontPx?: number;
  pad?: number;
  min?: number;
  max?: number;
}

export function measureLabelExtent(
  labels: string[],
  // pad — 라벨 폭 + 축 여백(tick offset·굵기 렌더 오차 흡수). 긴 한글 라벨(예: '강원특별자치도')이 렌더에서
  // 실측보다 넓어 앞글자가 잘리던 것 보정(측정≈render 이나 tick weight/offset 로 ~1자 부족 → 여유 확보).
  { fontPx = 12, pad = 32, min = 64, max = 240 }: MeasureLabelOptions = {},
): number {
  const fallback = () =>
    Math.min(max, Math.max(min, labels.reduce((m, l) => Math.max(m, l.length), 0) * 12 + pad));
  if (typeof document === 'undefined') return fallback();
  measureCanvas ??= document.createElement('canvas');
  const ctx = measureCanvas.getContext('2d');
  if (!ctx) return fallback();
  ctx.font = resolvedFont(fontPx);
  let widest = 0;
  for (const l of labels) widest = Math.max(widest, ctx.measureText(l).width);
  return Math.min(max, Math.max(min, Math.ceil(widest) + pad));
}
